<app-public-sort-panel
  (sortTypeChange)="sortTypeChange.emit($event)"
  [selectItems]="valueOrDefault(selectItems$ | async, [])" />
